<template>
  <!-- <v-layout row>
    <v-flex
      xs12
      sm6
      offset-sm3>
      <v-card>
        <v-toolbar
          color="secondary"
          dark>
          <v-toolbar-side-icon><v-icon>fas fa-comment-alt-smile</v-icon></v-toolbar-side-icon>

          <v-toolbar-title>Feedback und Ideen</v-toolbar-title>
        </v-toolbar> -->
       
  <iframe
    style="width: 100%; height: 100vh;"
    src="https://www.wevent-news.de/feedback-formular/" />

  <!-- <v-card-text 
          class="pt-0 pb-1"
          v-html="cleanUpHtml(page.data[1].content.rendered)">
        </v-card-text> -->
  <!-- </v-card>
    </v-flex>
  </v-layout> -->
</template>

<script>


export default { 
  data() {
    return {
      nodata: false,
      loadposts: false,
      page: '',
      posts: []
    }
  },
  
  
}
</script>
